import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Dashboard from './pages/Dashboard';
import GraphView from './pages/GraphView';
import QuizApp from './pages/QuizApp';
import TrainingPortal from './pages/TrainingPortal';
import TrainingAdmin from './pages/TrainingAdmin';
import UserManagement from './pages/UserManagement';
import AccountManagement from './pages/AccountManagement';
import ResourceList from './components/crud/ResourceList';
import ResourceCreate from './components/crud/ResourceCreate';
import ResourceEdit from './components/crud/ResourceEdit';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import FirstLoginModal from './components/auth/FirstLoginModal';
import './styles/mobile.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <FirstLoginModal />
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Student & Learner Accessible Routes - Root / is primary, /training redirects to / */}
          <Route path="/" element={<ProtectedRoute><TrainingPortal /></ProtectedRoute>} />
          <Route path="/training" element={<Navigate to="/" replace />} />
          <Route path="/quiz" element={<ProtectedRoute><QuizApp /></ProtectedRoute>} />

          {/* Management & Administration - Focused dedicated shell for Exam Accounts */}
          <Route path="/admin" element={<Navigate to="/admin/accounts" replace />} />
          <Route path="/admin/accounts" element={<AdminRoute roles={['admin', 'administrator', 'center']}><AccountManagement /></AdminRoute>} />
          <Route path="/admin/training" element={<Navigate to="/admin/accounts" replace />} />
          <Route path="/admin/users" element={<Navigate to="/admin/accounts" replace />} />
          <Route path="/dashboard" element={<Navigate to="/admin/accounts" replace />} />
          <Route path="/course/*" element={<Navigate to="/admin/accounts" replace />} />
          <Route path="/resources/*" element={<Navigate to="/admin/accounts" replace />} />

          {/* Catch-all for any other route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
